"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _excluded = ["checked", "className", "defaultChecked", "disabled", "id", "label", "onChange", "style"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StyledCheckbox = _styledComponents.default.label.withConfig({
  displayName: "Checkbox__StyledCheckbox",
  componentId: "uzjfh4-0"
})(["cursor:pointer;display:inline-block;margin:", " 0;position:relative;padding-top:", ";-webkit-tap-highlight-color:transparent;", " ", ""], function (props) {
  return props.theme.spacing.small;
}, function (props) {
  return props.theme.spacing.xxsmall;
}, function (_ref) {
  var disabled = _ref.disabled;
  return disabled && (0, _styledComponents.css)(["cursor:", ";pointer-events:", ";"], function (props) {
    return props.theme.luna ? 'not-allowed' : 'default';
  }, function (props) {
    return props.theme.luna ? 'auto' : 'none';
  });
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.luna && (0, _styledComponents.css)([":hover ", "{border-color:", ";}"], Icon, function (props) {
    return props.theme.luna.colors.neutral(90);
  });
});

var Icon = _styledComponents.default.span.withConfig({
  displayName: "Checkbox__Icon",
  componentId: "uzjfh4-1"
})(["border:", " solid ", ";border-radius:", ";height:", ";left:0;position:absolute;top:0;width:", ";&::after{border:solid ", ";border-width:0 ", " ", " 0;content:'';opacity:0;height:", ";left:", ";padding:", ";position:absolute;top:", ";transform:rotate(45deg);width:", ";}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.luna ? '1px' : theme.spacing.xxsmall;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.luna ? theme.luna.colors.neutral(50) : theme.colors.neutral.halfDollar;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.luna ? '2px' : theme.spacing.xsmall;
}, (0, _polished.rem)('20px'), (0, _polished.rem)('20px'), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.neutral.white;
}, function (props) {
  return props.theme.spacing.xxsmall;
}, function (props) {
  return props.theme.spacing.xxsmall;
}, (0, _polished.rem)('10px'), (0, _polished.rem)('7px'), function (props) {
  return props.theme.spacing.xxsmall;
}, function (props) {
  return props.theme.spacing.xsmall;
}, (0, _polished.rem)('7px'));

var Input = _styledComponents.default.input.withConfig({
  displayName: "Checkbox__Input",
  componentId: "uzjfh4-2"
})(["", ""], function (_ref7) {
  var _ref7$theme = _ref7.theme,
      _ref7$theme$colors = _ref7$theme.colors,
      neutral = _ref7$theme$colors.neutral,
      system = _ref7$theme$colors.system,
      luna = _ref7$theme.luna;
  return (0, _styledComponents.css)(["opacity:0;position:absolute;&:checked ~ ", "{background-color:", ";border:solid ", ";border:0;transform:scale(1);transition:", ";}&:disabled ~ ", "{border-color:", ";}&:checked:focus ~ ", "{background-color:", ";}&:disabled:checked ~ ", "{background-color:", ";}", " &:checked ~ ", "::after{display:block;opacity:1;}"], Icon, luna ? luna.colors.neutral(90) : system.cta.base, luna ? luna.colors.neutral(90) : neutral.white, luna ? 'none' : '0.4s cubic-bezier(0.25, 0.8, 0.25, 1)', Icon, luna ? luna.colors.neutral(40) : neutral.quarter, Icon, luna ? luna.colors.neutral(90) : system.cta.hover, Icon, luna ? luna.colors.neutral(40) : neutral.quarter, function (_ref8) {
    var wasClicked = _ref8.wasClicked;
    return !wasClicked && (0, _styledComponents.css)(["&:focus ~ ", "{border-color:", ";box-shadow:", ";}"], Icon, luna ? luna.colors.neutral(90) : system.cta.hover, luna ? '0 0 0 2px ' + luna.colors.neutral(90) : '0 0 5px 2px ' + (0, _polished.rgba)(system.cta.base, 0.8));
  }, Icon);
});

var Label = _styledComponents.default.span.withConfig({
  displayName: "Checkbox__Label",
  componentId: "uzjfh4-3"
})(["margin-left:", ";margin-right:", ";letter-spacing:", ";"], (0, _polished.rem)('28px'), function (props) {
  return props.theme.spacing.medium;
}, (0, _polished.rem)('0.5px'));

var Checkbox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Checkbox, _Component);

  var _super = _createSuper(Checkbox);

  function Checkbox(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Checkbox);
    _this = _super.call(this, props);
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      wasClicked: false
    };
    return _this;
  }

  (0, _createClass2.default)(Checkbox, [{
    key: "handleBlur",
    value: function handleBlur(event) {
      this.setState({
        wasClicked: false
      });

      if (this.props.onBlur) {
        this.props.onBlur(event);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      // Prevent focus styling on user click
      if (event.target !== event.currentTarget.control) {
        this.setState({
          wasClicked: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          checked = _this$props.checked,
          className = _this$props.className,
          defaultChecked = _this$props.defaultChecked,
          disabled = _this$props.disabled,
          id = _this$props.id,
          label = _this$props.label,
          onChange = _this$props.onChange,
          style = _this$props.style,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var wasClicked = this.state.wasClicked;
      var classes = (0, _classnames.default)('ui-checkbox', className, {
        'ui-checkbox--disabled': disabled,
        'ui-checkbox--checked': checked,
        'ui-checkbox--clicked': wasClicked
      });
      return /*#__PURE__*/_react.default.createElement(StyledCheckbox, {
        className: classes,
        disabled: disabled,
        htmlFor: id,
        style: style,
        onClick: this.handleClick
      }, /*#__PURE__*/_react.default.createElement(Input, (0, _extends2.default)({}, otherProps, {
        checked: checked,
        defaultChecked: defaultChecked,
        disabled: disabled,
        id: id,
        onBlur: this.handleBlur,
        onChange: onChange,
        type: "checkbox",
        wasClicked: wasClicked
      })), /*#__PURE__*/_react.default.createElement(Icon, {
        className: "ui-checkbox-icon"
      }), /*#__PURE__*/_react.default.createElement(Label, {
        className: "ui-checkbox-label"
      }, label));
    }
  }]);
  return Checkbox;
}(_react.Component);

exports.default = Checkbox;
Checkbox.propTypes = {
  /** Checks `input` if true (for controlled components). */
  checked: _propTypes.default.bool,

  /** Custom class name to add to Checkbox. This also allows you to use the styled(Component) notation. */
  className: _propTypes.default.string,

  /** Checks `input` if true (for uncontrolled components). */
  defaultChecked: _propTypes.default.bool,

  /** Disables Checkbox if `true`. */
  disabled: _propTypes.default.bool,

  /** ID attribute for `input`. Also sets the `htmlFor` attribute for `label`. */
  id: _propTypes.default.string,

  /**  Label displayed next to the checkbox. */
  label: _propTypes.default.node,

  /** Event handler called when `input` loses focus. */
  onBlur: _propTypes.default.func,

  /** Event handler called when `input` changes. */
  onChange: _propTypes.default.func,

  /** Adds inline styles to Checkbox. */
  style: _propTypes.default.object
};
//# sourceMappingURL=Checkbox.js.map